<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a parallel solution concept</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title> 
                <span class="headline font-weight-bold">Add a parallel solution concept:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-text-field outline label="Add Solution name" v-model="solutionname" :rules="textInputRules"></v-text-field>
                    <v-textarea outline label="Add Solution description" v-model="solutiondescription" :rules="textInputRules"></v-textarea>
                    <v-checkbox v-model="solutiondetaildoesthissolutionhavedisruptivequalities" label="This solution concept has disruptive qualities"></v-checkbox>
                    <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Solution concept</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Solution concept</v-btn> 
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Quote</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            solutionname: 'Calendar Synk',
            solutiondescription: 'Syncs ToDos with a calendar and allows for meetings scheduling and meeting notes',
            solutiondetaildoesthissolutionhavedisruptivequalities: false,
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const quote = {
                solutionname: this.solutionname,
                solutiondescription: this.solutiondescription,
                solusolutiondetaildoesthissolutionhavedisruptivequalitiestionname: this.solutiondetaildoesthissolutionhavedisruptivequalities
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('parallelsolutionconcepts');

        dbref.add(quote).then(() =>{
            //console.log('Parallel solution concept added')
                      this.loading = false;
          this.dialog = false;
          this.$emit('quoteconfirmed')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
